let host = window.location.host.indexOf('localhost') > -1 ? 'local' : window.location.host.replace('test.icru.co.kr', '').replace('jng.icru.co.kr', '');
if (!host) host = 'prod';
console.log(host)

let appVersion = 'APP_VERSION';
let buildVersion = 'BUILD_VERSION';

const config = {
	local: {
		CLIENT_ID: 'kr.co.icru',
		API_URL: 'http://localhost:31011/api/v2',
		appVersion,
		buildVersion,
	},
	prod: {
		CLIENT_ID: 'kr.co.icru',
		API_URL: 'https://test.icru.co.kr/api/v2',
		appVersion,
		buildVersion,
	},
};

export default config[host];
